import styled from "@emotion/styled";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import { accountAtom } from "shared/lib/account";

import { useLoginDialogStateHelper } from "scmp-app/components/login-dialog/hooks";
import { rosettaAtom } from "scmp-app/lib/rosetta";

import {
  ButtonWrapper,
  Container,
  Content,
  HighlightedContent,
  LoginMessage,
  LoginText,
  LoginWrapper,
  StyledButton,
  StyledLogo,
  Wrapper,
} from "./styles";

const Component: FunctionComponent = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const { isLoggedIn } = useAtomValue(accountAtom);
  const hasScmpPlusUpgradeOptions = asyncRosettaState?.result?.user?.hasScmpPlusUpgradeOptions;

  const { openLoginDialog } = useLoginDialogStateHelper();

  const handleCTAClick = () => {
    window.open("https://subscribe.scmp.com/plus", "_blank");
  };

  const handleLoginClick = useCallback(() => {
    openLoginDialog({
      application: "scmp-plus",
      destination: window.location.href,
      ga4CustomParameter: {
        trigger_point: "plus_inline_widget",
      },
    });
  }, [openLoginDialog]);

  const ctaLabel = (() => {
    if (!isLoggedIn) return "TRY FOR FREE or UPGRADE";
    if (hasScmpPlusUpgradeOptions) return "UPGRADE";
    return "TRY FOR FREE";
  })();

  return (
    <Container>
      <StyledLogo />
      <Wrapper>
        <Content>
          SCMP Plus is a new premium news platform that gives you an
          <HighlightedContent>
            {" "}
            all-inclusive edge to stay ahead on China news.
          </HighlightedContent>{" "}
          To access our exclusive content you’ll need to subscribe.
        </Content>
        <ButtonWrapper>
          <StyledButton onClick={handleCTAClick}>{ctaLabel}</StyledButton>
          <LoginWrapper>
            <LoginMessage>Already a subscriber?</LoginMessage>
            <LoginText onClick={handleLoginClick}>LOG IN</LoginText>
          </LoginWrapper>
        </ButtonWrapper>
      </Wrapper>
    </Container>
  );
};

Component.displayName = "InlinePlusWidgetNonSubscriber";

export const InlinePlusWidgetNonSubscriber = styled(Component)``;
